import React, { Component } from "react";
import { withRouter } from "react-router";
import { Switch, Route } from "react-router-dom";

import { Utils, Toastr } from "arv-reactcomponents";
import Footer from "../component/Footer";
// import FooterSmall from "../component/FooterSmall";
import Header from "../component/Header";
import Listing from "../pages/Listing";
import Pdp from "../pages/Pdp";
import StoreLocator from "../pages/StoreLocator";
import BrandPage from "../pages/BrandPage";
import { Login } from "../component/Login";
import UiRoutingComponent from "./UiRoutingComponent";
import { queryParamsToObject, createCookie } from "../utils";
import { expiryTime } from "../constants";

if (process.env.REACT_APP_isNotCONSOLE) {
  window.console.log = Utils.noop;
}

Utils.polyfill();

Toastr.setConfig({
  limitTo: 1, // Change default value of limitTo to `3`
});

const publicPath = "/";
export const routeCodes = {
  Header: `${publicPath}`,
  Login: `${publicPath}`,
  StoreLocator: `${publicPath}store-locator`,
  Search: `${publicPath}`,
  Product: `${publicPath}products`,
  Footer: `${publicPath}`,
  Style: `${publicPath}style`,
  NOTFOUND: `*`,
};
// addLocaleData([...en, ...es, ...fr, ...ru]);
// const messages = {};

@withRouter
class App extends Component {
  componentDidMount() {
    if (window) {
      window.onpageshow = function(event) {
        if (event.persisted) {
          window.location.reload();
        }
        const urlQueryParams = queryParamsToObject(window.location.search);
        if (urlQueryParams.utm_medium) {
          createCookie("utm_medium", urlQueryParams.utm_medium, 2592000000);
        }
      };
    }
  }
  render() {
    return (
      <div>
        <div className="nw-app">
          <Route path={routeCodes.Header} component={Header} />
          <div className="nw-app-body">
            <Switch>
              <Route exact path="/" component={BrandPage} />
              <Route path="/store-locator" component={StoreLocator} />
              <Route path="/style" component={Pdp} />
              <Route path="/products" component={Listing} />
              <Route path="/search" component={Listing} />
              <Route path="/:type" component={UiRoutingComponent} />
            </Switch>
          </div>
          <Route
            path={routeCodes.Footer}
            component={props => {
              if (props.location.pathname.indexOf("store-locator") > -1) {
                return <span />;
              }
              return <Footer />;
            }}
          />
          <Route path={routeCodes.Login} component={Login} />
        </div>
      </div>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App/index.js